import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { authAtom } from "stores";
import { useSetRecoilState } from "recoil";

import { onAuthRes } from "./helper";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const getAuth = async () => axios.get(Routes.AUTH);

export const useGetAuth = () => {
  const setAuth = useSetRecoilState(authAtom);

  return useQuery({
    queryKey: [Keys.AUTH_QRY],
    queryFn: getAuth,
    onSuccess: (res) => onAuthRes({ auth: res.data, setAuth }),
    enabled: false,
    retry: false,
  });
};
